module.exports = "<p>\n  pricing-booking -respensiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiiivee works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/pricing-booking-responsive/pricing-booking.component.html
// module id = ./src/app/component/pricing-booking-responsive/pricing-booking.component.html
// module chunks = main